import { TextSelection } from "@tiptap/pm/state";

import { TextVisitor } from "@/models/nodes/visitors/TextVisitor";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeWithPos } from "@tiptap/core";
import type { Node as ProseMirrorNode } from "@tiptap/pm/model";
import type { EditorState, Transaction } from "@tiptap/pm/state";

export function transformInlineExpressionsToText(
  { node, pos: nodePosition }: NodeWithPos,
  state: EditorState,
  doc: DocumentModel,
  descend?: boolean,
): Transaction {
  const { tr } = state;
  let offset = 0;

  node.descendants((childNode: ProseMirrorNode, pos: number) => {
    if (childNode.type.name === "inlineExpression") {
      const { nodeId } = childNode.attrs;
      const expressionNode = doc.nodes.get(nodeId as string);

      if (expressionNode) {
        const text = expressionNode.accept(new TextVisitor());

        if (text) {
          const textNode = state.schema.text(text);
          const from = nodePosition + pos + 1 + offset;
          const to = from + childNode.nodeSize;

          const { selection } = state;
          const selectionIsInNode = selection.from >= from && selection.from <= to;

          tr.replaceWith(from, to, textNode);

          offset += textNode.nodeSize - childNode.nodeSize;

          if (selectionIsInNode) {
            tr.setSelection(TextSelection.create(tr.doc, from + textNode.nodeSize));
          }
        }
      }
    }

    return !!descend;
  });

  return tr;
}
